import { styled } from "@vw-marketing/us-components";

export const StyledInformationBoxContainer: any = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  width: 100%;
`;
